import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, UntypedFormControl, Validators, ValidatorFn, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MessageService } from 'base';
import { ConfigurationService } from '../../services/configuration.service';
import { OnDestroy } from '@angular/core';
import { ComponentBase } from 'common';
import { StringUtils } from 'DiscoveryEngine.TS/Utils';
import { Integration, IntegrationNames, IntegrationTable } from '../../../DiscoveryEngine.TS/Core/Integration';


@Component({
	selector: 'patch-manager-settings',
	templateUrl: './patch-manager-settings.component.html',
	styleUrls: ['./patch-manager-settings.component.scss']
})
export class PatchManagerSettingsComponent extends ComponentBase implements OnInit, OnDestroy, OnChanges {
	@Input()
	public inputSettings: Integration;

	public form: UntypedFormGroup;

	public enabled: UntypedFormControl;

	public serverURL: UntypedFormControl;
	public username: UntypedFormControl;
	public password: UntypedFormControl;

	private passwordChanged: boolean;
	private passwordChangedSub: Subscription;

	constructor(private fb: UntypedFormBuilder,
		private configService: ConfigurationService,
		private messageService: MessageService) {

		super();
	}

	public ngOnInit(): void {
		this.buildForm();
	}

	public ngOnDestroy(): void {
		if (this.passwordChangedSub) {
			this.passwordChangedSub.unsubscribe();
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.buildForm();
	}

	private buildForm(): void {
		this.enabled = undefined;
		this.serverURL = undefined;
		this.username = undefined;
		this.password = undefined;

		let enabled = true;
		let serverURL = "";
		let username = "";
		let password = "";

		if (this.inputSettings) {
			enabled = this.inputSettings.Enabled;
			serverURL = this.inputSettings.ServerURL;
			username = this.inputSettings.Username;
			password = (this.inputSettings.HasPassword ? this.hidePassword(this.inputSettings.Password) : "");
		}

		this.enabled = new UntypedFormControl(enabled);
		this.serverURL = new UntypedFormControl(serverURL);
		this.username = new UntypedFormControl(username);
		this.password = new UntypedFormControl(password);

		this.passwordChanged = false;
		this.passwordChangedSub = this.password.valueChanges.subscribe(() => {
			this.passwordChanged = true;
		});

		this.form = this.fb.group({
			enabled: this.enabled,
			serverURL: this.serverURL,
			username: this.username,
			password: this.password,
		},
		{
			validator: Validators.compose([
				this.noneOrAllSettings(),
			])
		});
	}

	public enableSave(): boolean {
		return !this.form.invalid;
	}

	public onSave(): void {
		const outputIntegrationTable = new IntegrationTable();
		const integrationSettings = this.getIntegrationSettings();
		outputIntegrationTable.Add(integrationSettings);
		this.configService.setIntegrationTable(outputIntegrationTable).subscribe(
			() => {
				this.messageService.displayInfoMessage("Successfully saved Patch Manager default settings");
			},
			(error) => {
				this.messageService.displayErrorMessage("Failed to save Patch Manager default settings");
			});
	}

	public onPasswordKeyDownHandler(event: any): void {
		if (!this.passwordChanged) {
			this.passwordChanged = true;

			this.password.setValue('');
			this.password.markAsDirty();
		}
	}

	public getIntegrationSettings(): Integration {
		const outputIntegration = new Integration(IntegrationNames.PatchManager);
		outputIntegration.Enabled = this.enabled.value;
		outputIntegration.ServerURL = this.serverURL.value;
		outputIntegration.Username = this.username.value;
		if (this.passwordChanged) {
			outputIntegration.Password = StringUtils.ObfuscateString2(this.password.value);
		}
		else {
			outputIntegration.Password = this.inputSettings.Password;
		}

		return outputIntegration;
	}

	private noneOrAllSettings(): ValidatorFn {
		return () => {
			let b1 = (!!this.serverURL.value !== !!this.username.value);
			let b2 = (!!this.username.value !== !!this.password.value);
			//let b3 = (!!this.password.value !== !!this.confirmPassword.value);
			if (b1 || b2) {
				return {
					noneOrAllSettings: { valid: false }
				};
			}

			return null;
		}
	}

}
